import { TOPUP_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { PackageActionRequestEntity } from "features/packageManagement/domain/entities/PackageActionEntity";
import { PackageListRequestEntity } from "features/packageManagement/domain/entities/PackageListRequestEntity";
import { IPackageManagementRepository } from "features/packageManagement/domain/repositories/IPackageManagementRepository";
import { injectable } from "tsyringe";
import { MobileDataService } from "utils/enums/MobileDataEnums";
import {
  PackageActionRequestModel,
  PackageCategoryAdditionRequestModel,
  PackageCategoryModel,
  PackageCreateRequestModel,
  PackageDetailModel,
  PackageListRequestModel,
  PackageResponseModel,
  PackageSupplierAdditionRequestModel,
  PackageSupplierModel,
} from "./model/PackageManagementModels";

@injectable()
export class PackageManagementImpl implements IPackageManagementRepository {
  async getPackageList(
    params: PackageListRequestModel,
  ): Promise<ListBaseApiResponseModel<PackageResponseModel>> {
    const request = params as PackageListRequestEntity;
    const { categoriesForQuery, category, ...query } = request;
    const isBuyPackage = request.service === MobileDataService.BuyPackage;
    const categories = [categoriesForQuery, category].filter(
      (value, index, values): value is string =>
        Boolean(value) && values.indexOf(value) === index,
    );
    const categoryQuery = categories
      .map((value, index) => `categories[${index}]=${value}`)
      .join("&");
    const requestParams = isBuyPackage ? { ...query, category } : query;
    const url =
      !isBuyPackage && categoryQuery
        ? `${TOPUP_MANAGEMENT.LIST}?${categoryQuery}`
        : TOPUP_MANAGEMENT.LIST;

    return client.get(url, requestParams);
  }

  async getPackageDetail(
    id: string,
  ): Promise<BaseApiResponseModel<PackageDetailModel>> {
    return client.get(`${TOPUP_MANAGEMENT.DETAIL}/${id}/info`);
  }

  async updatePackage(
    body: PackageActionRequestModel,
  ): Promise<BaseApiResponseModel<PackageResponseModel>> {
    const { id, ...payload } = body as PackageActionRequestEntity;
    return client.put(`${TOPUP_MANAGEMENT.UPDATEV2}/${id}/update`, payload);
  }

  async createPackage(
    body: PackageCreateRequestModel,
  ): Promise<BaseApiResponseModel<PackageResponseModel>> {
    return client.post(TOPUP_MANAGEMENT.CREATEV2, body);
  }

  async addPackageSupplier(
    body: PackageSupplierAdditionRequestModel,
  ): Promise<BaseApiResponseModel<PackageSupplierModel[]>> {
    return client.post(TOPUP_MANAGEMENT.ADD_SUPPLIER, body);
  }

  async addPackageCategory(
    body: PackageCategoryAdditionRequestModel,
  ): Promise<BaseApiResponseModel<PackageCategoryModel[]>> {
    return client.post(TOPUP_MANAGEMENT.ADD_CATEGORY, body);
  }
}
